import React, { useState, useEffect, useCallback } from "react";
import {
  Input,
  Row,
  Col,
  Form,
  Select,
  DatePicker,
  Popconfirm,
  Button,
  Table,
  message,
  Card,
  Upload,
  InputNumber,
  Spin,
} from "antd";
import moment from "moment";
import { DeleteOutlined, UploadOutlined } from "@ant-design/icons";
import genderList from "../../assets/data/gender.data.json";
import documentListData from "../../assets/data/document-type.data.json";
import relationshipListData from "../../assets/data/relationship.data.json";
import ethnicityListData from "../../assets/data/ethnicity.data.json";
import StudentService from "../../../src/services/StudentService";
import CommonService from "../../../src/services/CommonService";
import WaiverService from "../../../src/services/WaiverService";
import AcademicService from "../../../src/services/AcademicService";
import { debounce } from "lodash";
import { STATUS_CODE } from "../../constants/ApiConstant";
import axios from "axios";

const Option = Select;

const currentYear = moment().year();
const StudentInfo = (props) => {
  const { step, setStep, selectedCourseList, studentData, setStudentData, waiveoffType, setWaiveoffType, setStudentId} =
    props;
  const [form] = Form.useForm();
  const [countriesList, setCountry] = useState([]);
  const [academicSession, setAcademicSession] = useState([]);
  const [parentStateList, setParentState] = useState([]);
  const [studentStateList, setStudentState] = useState([]);
  const [documentList, setDocumentList] = useState([]);
  const [docList, setDocList] = useState([]);
  const [addedDocumentTypes, setAddedDocumentTypes] = useState([]);
  const [pageStep, setPageStep] = useState(1);
  const [isActive, setIsActive] = useState(false);
  const [waveType, setWaveType] = useState(false);
  const { Option } = Select;
  const EntredStudenId = localStorage.getItem("EntredStudenId") || '{}';
  const StudentDetails = JSON.parse(localStorage.getItem("StudentDetail") || '{}');
  const jsonDataString = StudentDetails?.jsonData || '{}';
  const parsedStudentData = {
    "FirstName": "Vincent",
    "LastName": "Schultz",
    "MobileNumber": "3883838383",
    "EmailAddress": "foledo3179@ahanim.com",
    "Password": "12345678",
    "ConfirmPassword": "12345678",
    "MiddleName": "Morgan Cabrera",
    "Dob": "1970-10-06T00:00:00",
    "CurrentGrade": "6",
    "InterestedGrade": "299",
    "SchoolYear": "2026-2027",
    "CurrentSchool": "",
    "ReferralOption": "Website",
    "AcceptTerms": true,
    "Parent": {
        "NameTitle": "Prof.",
        "FirstName": "Nevada",
        "MiddleName": "Gretchen Lloyd",
        "LastName": "Mueller",
        "Relationship": "Sister",
        "Email": "foledo3179@ahanim.com",
        "PhoneNo": "+91 3883838383"
    },
    "ParentAddress": {
        "Address": "Dolore odio qui offi",
        "City": "Dehradun",
        "State": "UTTARAKHAND",
        "PinCode": "248005"
    }
}
  const [questionData, setQuestionData] = useState([]);
  const [pincodeData, setPincodeData] = useState(null);
  const [countryCodeList, setCountryCodeList] = useState([]);
  const [loading, setLoading] = useState(false);
  const studentId = localStorage.getItem("studenId");
  const [question, setQuestion] = useState("");
  const [certificateFile, setFileList] = useState([]);

  console.log("student detals are", StudentDetails)
  console.log("student data is coming", studentData)


  useEffect(() => {

    getStudentInfo();
    populateCountry();
    getAcademicSession();
    setFromState();
    GetStudentQuestion();
  }, []);

  const populateCountry = () => {
    CommonService.getAllCountries().then((res) => {
      setCountry(res.data);
    });
  };

  useEffect(() => {
    console.log("parse value", parsedStudentData)
    if (parsedStudentData?.Parent?.PhoneNo) {
      const phone = parsedStudentData?.Parent?.PhoneNo.trim();
      const [dialCode, number] = phone?.split(" ");
      const selectedCountry = countryCodeList?.find(
        (c) => c.dialCode === dialCode
      );

      form.setFieldsValue({
        selectedCountryCode: selectedCountry?.code,
        countryCode: selectedCountry?.code,
      });
    }
    if (parsedStudentData?.InterestedGrade) {
      const matchedCourse = props.courseList?.find(
        (elm) => elm.title === parsedStudentData.InterestedGrade
      );
      if (matchedCourse) {
        form.setFieldValue("gradeId", matchedCourse.id);
      }
    }
    if (studentData?.parent?.Relationship && relationshipListData?.length > 0) {
      // Find matching relationship id
      const match = relationshipListData.find(
        (r) => r.title.toLowerCase() === studentData.parent.Relationship.toLowerCase()
      );

      form.setFieldValue("relationshipId", match?.id || "0");
    }
  }, [form, countryCodeList, parsedStudentData, props.courseList, relationshipListData]);

  const getAcademicSession = () => {
    AcademicService.getList().then((res) => {
      setAcademicSession(res);
    });
  };

  const passingYear = [];
  for (let i = 2010; i <= currentYear; i++) {
    passingYear.push(i);
  }

  const setFromState = async () => {

    if (studentData) {
      // student details saving 
      if (Array.isArray(studentData) ? (studentData.length > 0) : (Object.keys(studentData).length)) {
        if (studentData?.countryId) {
          await CommonService.getAllStateByCountryId(studentData?.countryId).then((res) => {
            setStudentState(res.data);
          });
        }
        form.setFieldValue('firstName', studentData?.firstName);
        form.setFieldValue('middleName', studentData?.middleName);
        form.setFieldValue('lastName', studentData?.lastName);
        form.setFieldValue('emailAddress', studentData?.emailAddress);
        form.setFieldValue('academicSessionId', studentData?.academicSessionId);
        form.setFieldValue('enrollmentNumber', studentData?.enrollmentNumber);
        form.setFieldValue('mobileNumber', studentData?.mobileNumber);
        form.setFieldValue('genderId', studentData?.genderId);
        // form.setFieldValue('studentPassword', studentData?.password);
        // form.setFieldValue('confirmStudentPassword', studentData?.password);
        form.setFieldValue('statusId', studentData?.statusId);
        form.setFieldValue('dateofBirth', studentData.dateofBirth);
        // Student Address details
        form.setFieldValue('countryId', studentData?.countryId);
        form.setFieldValue('city', studentData?.address.city);
        form.setFieldValue('address', studentData?.address.line1);
        form.setFieldValue('stateId', studentData?.address.stateId);
        form.setFieldValue('pincode', studentData?.pincode);

        // parent details 
        if (studentData.hasOwnProperty("parent")) {
          if (studentData?.parent?.parentCountryId) {
            await CommonService.getAllStateByCountryId(studentData?.parent?.parentCountryId).then((res) => {
              setParentState(res.data);
            });
          }
          form.setFieldValue('parentFirstName', studentData?.parent.firstName);
          form.setFieldValue('parentMiddleName', studentData?.parent.middleName);
          form.setFieldValue('parentLastName', studentData?.parent.lastName);
          form.setFieldValue('relationshipId', studentData?.parent.relationshipId);
          form.setFieldValue('parentMobileNumber', studentData?.parent.mobileNumber);
          form.setFieldValue('email', studentData?.parent.emailAddress);
          form.setFieldValue('parentPassword', studentData?.parent.password);
          form.setFieldValue('confirmPassword', studentData?.parent.password);
          form.setFieldValue('parentCity', studentData?.parent.address.city);

          // Parent address
          form.setFieldValue('countryCode', studentData?.parent.parentCountryId);
          form.setFieldValue('parentAddress', studentData?.parent.address.line1);
          form.setFieldValue('parentStateId', studentData?.parent.address.stateId);
          form.setFieldValue('parentPinCode', studentData?.parent.address.pinCode);
        }
      }
    }
    else {
      form.setFieldValue('firstName', StudentDetails?.firstName);
      form.setFieldValue('lastName', StudentDetails?.lastName);
      form.setFieldValue('mobileNumber', StudentDetails?.mobileNumber);
      form.setFieldValue('emailAddress', StudentDetails?.emailAddress);
    }
  }




  const getStudentInfo = () => {

    if (studentId) {
      // if (studentId) {
      StudentService.getById(studentId).then((res) => {
        if (res?.data?.statusCode === '404') {
          setIsActive(true);
        } else {
          setIsActive(false);
        }
        if (res.data.statusCode === STATUS_CODE.NOT_EXISTS) {
          message.warning(`Student does not exist`);
        } else {
          const studentInfo = res.data;
          const parentInfo = res.data.parentInfo;
          const academicInfo = res.data.academicInfo;
          handleParentCountryChange(parentInfo?.address.countryId);
          handleStudentCountryChange(parentInfo?.address.countryId);
          form.setFieldsValue({
            parentFirstName: parentInfo?.firstName,
            parentMiddleName: parentInfo?.middleName,
            parentLastName: parentInfo?.lastName,
            parentEmailAddress: parentInfo?.emailAddress,
            parentMobileNumber: parentInfo?.mobileNumber,
            relationshipId: parentInfo?.relationshipId,
            occupationId: parentInfo?.occupationId,
            parentAddress: parentInfo?.address.line1,
            parentCountryId: parentInfo?.address.countryId,
            parentStateId: parentInfo?.address.stateId,
            parentCity: parentInfo?.address.city,
            parentPinCode: parentInfo?.address.pinCode,
            firstName: studentInfo?.firstName,
            middleName: studentInfo?.middleName,
            lastName: studentInfo?.lastName,
            emailAddress: studentInfo?.emailAddress,
            mobileNumber: studentInfo?.mobileNumber,
            ethnicityId: studentInfo?.ethnicityId,
            genderId: studentInfo?.genderId,
            dateofBirth: moment(studentInfo?.dateofBirth),
            address: studentInfo?.address.line1,
            countryId: studentInfo?.address.countryId,
            stateId: studentInfo?.address.stateId,
            city: studentInfo?.address.city,
            pinCode: studentInfo?.address.pinCode,
            currentSchool: academicInfo?.currentSchool,
            gradeId: academicInfo?.gradeId,
            passingYear: academicInfo?.passingYear,
            cgpa: academicInfo?.cgpa,
          });
        }
      });
    } else {
      // 
      const pincode = parsedStudentData?.ParentAddress?.PinCode;
      const City = parsedStudentData?.ParentAddress?.City;
      const savedPassword = parsedStudentData?.Password;
      const cleaned = parsedStudentData?.Parent?.PhoneNo
      let ParentPhones = cleaned?.replace("+91", "").replace(/\s/g, "");
      if (pincode && pincode.length === 6) {
        handleInputChange(pincode);
      } if (City && City.length === 6) {
        handleInputChange(pincode);
      }
      form.setFieldValue('firstName', parsedStudentData?.FirstName || '');
      form.setFieldValue('middleName', parsedStudentData?.MiddleName || '');
      form.setFieldValue('lastName', parsedStudentData?.LastName || '');
      form.setFieldValue('mobileNumber', parsedStudentData?.MobileNumber || '');
      form.setFieldValue('emailAddress', parsedStudentData?.EmailAddress || '');
      form.setFieldValue('address', parsedStudentData?.ParentAddress?.Address || '');
      form.setFieldValue('password', parsedStudentData?.Password || '');
      form.setFieldValue('confirmPassword', parsedStudentData?.ConfirmPassword || '');
      form.setFieldValue(
        "dateofBirth",
        parsedStudentData?.Dob ? moment(parsedStudentData.Dob, "YYYY-MM-DDTHH:mm:ss") : null
      );
      form.setFieldValue('genderId', parsedStudentData?.Genderid || '');

      form.setFieldValue('currentGrade', parsedStudentData?.CurrentGrade || '');
      form.setFieldValue('interestedGrade', parsedStudentData?.InterestedGrade || '');
      form.setFieldValue('schoolYear', parsedStudentData?.SchoolYear || '');
      form.setFieldValue('currentSchool', parsedStudentData?.CurrentSchool || '');
      form.setFieldValue('referralOption', parsedStudentData?.ReferralOption || '');
      form.setFieldValue('acceptTerms', parsedStudentData?.AcceptTerms || false);
      form.setFieldValue('village', City || '');
      // form.setFieldValue('pinCode', pincode || '');
      form.setFieldValue('pincode', pincode || '');

      // Parent/Guardian fields
      form.setFieldValue('parentNameTitle', parsedStudentData?.Parent?.NameTitle || '');
      form.setFieldValue('parentFirstName', parsedStudentData?.Parent?.FirstName || '');
      form.setFieldValue('parentMiddleName', parsedStudentData?.Parent?.MiddleName || '');
      form.setFieldValue('parentLastName', parsedStudentData?.Parent?.LastName || '');
      form.setFieldValue('relationshipId', parsedStudentData?.Parent?.Relationship || '');
      form.setFieldValue('parentEmailAddress', parsedStudentData?.Parent?.Email || '');
      form.setFieldValue('parentMobileNumber', parsedStudentData?.Parent?.PhoneNo?.split(" ")[1] || '');
      form.setFieldsValue({
        parentPassword: savedPassword,
        confirmPassword: savedPassword,
      });

      // Parent Address 
      form.setFieldValue('parentAddress', parsedStudentData?.ParentAddress?.Address || '');
      form.setFieldValue('city', City || '');
      form.setFieldValue('state', parsedStudentData?.ParentAddress?.State || '');
      form.setFieldValue('parentPinCode', pincode || '');

      setIsActive(false);
    }
  };

  const handleCountryChange = (countryId, setStateFunc, fieldId) => {
    if (parseInt(countryId) > 0) {
      CommonService.getAllStateByCountryId(countryId).then((res) => {
        setStateFunc(res.data);
      });
    }
    setStateFunc([]);
    form.setFieldsValue({
      [fieldId]: "Select State",
    });
  };

  const handleParentCountryChange = (countryId) => {
    handleCountryChange(countryId, setParentState, "parentStateId");
  };

  const handleStudentCountryChange = (countryId) => {
    handleCountryChange(countryId, setStudentState, "stateId");
  };


  const handleAddAdmitDocument = async () => {
    // 
    try {
      const values = await form.validateFields(["waiveoffType", "docnumber", "certificate"]);
      const questionValues = await form.validateFields(["whyDoYouDeserveThisScholarship", "studentAnswer"]);
      const ansValues = await form.validateFields(['answer']);

      if (waiveoffType === "Waiveoff") {
        const selectedDocument = arr.find((doc) => doc.name === values.waiveoffType);

        if (!selectedDocument) {
          message.error(`Please select a valid admission type`);
          return;
        }

        const selectedDocumentType = selectedDocument.name;
        const checkAddedDocumetnt = docList.find((val) => val.typeId === 2);
        if (checkAddedDocumetnt) {
          message.error(`Cannot re-add a document`);
          return;
        }
        const file = values.certificate?.[0]?.originFileObj;
        if (!file || !values.docnumber) {
          message.error(`Please provide a document number and upload certificate`);
          return;
        }
        const base64Image = await getBase64(file);

        const newDocument = {
          typeId: 2,
          id: Date.now(),
          documentType: selectedDocumentType,
          documentNumber: values.docnumber,
          certificateBase64: base64Image,
        };
        setDocList((prevList) => [...prevList, newDocument]);
        setAddedDocumentTypes((prevTypes) => [...prevTypes, selectedDocumentType]);

      }
      else {
        const findedQuestion = questionData?.find((val) => val.id === question)
        if (docList?.find((val) => val.id === question)) {
          message.warning(`This question is already added`);
          return;
        }
        else {
          const newDocument = {
            typeId: 1,
            id: question,
            questionId: findedQuestion?.question,
            answerId: ansValues?.answer,
          }
          setDocList((prevList) => [...prevList, newDocument]);
          form.resetFields(["answer"]);
        }
      }
    } catch (error) {
      console.error("Validation failed:", error);
    }
  };

  const handleAddDocument = () => {
    form.validateFields(["documentId", "documentnumber"]).then((values) => {
      const selectedDocument = documentListData.find(
        (doc) => doc.id === values.documentId
      );
      if (selectedDocument) {
        const selectedDocumentType = selectedDocument.title;
        if (!addedDocumentTypes.includes(selectedDocumentType)) {
          if (values.documentnumber) {
            const newDocument = {
              id: Date.now(),
              documentType: selectedDocumentType,
              documentNumber: values.documentnumber,
            };

            setDocumentList((prevList) => [...prevList, newDocument]);
            setAddedDocumentTypes((prevTypes) => [
              ...prevTypes,
              selectedDocumentType,
            ]);
            message.success(`Document added successfully`);
            form.resetFields(["documentId", "documentnumber"]);
          } else {
            message.error(`Please provide a document number`);
          }
        } else {
          message.error(`Cannot re-add a document`);
        }
      } else {
        message.error(`Please select a document type`);
      }
    });
  };

  const handleDeleteDocument = (recordId) => {
    const documentToDelete = documentList.find((item) => item.id === recordId);
    const documentTypeToDelete = documentToDelete
      ? documentToDelete.documentType
      : null;
    setDocumentList((prevList) =>
      prevList.filter((item) => item.id !== recordId)
    );
    setAddedDocumentTypes((prevTypes) =>
      prevTypes.filter((type) => type !== documentTypeToDelete)
    );
  };

  const handleDeleteWaveDocuments = (recordId) => {
    const documentToDelete = docList.find((item) => item.id === recordId);
    const documentTypeToDelete = documentToDelete
      ? documentToDelete.documentType
      : null;
    setDocList((prevList) =>
      prevList.filter((item) => item.id !== recordId)
    );
    setAddedDocumentTypes((prevTypes) =>
      prevTypes.filter((type) => type !== documentTypeToDelete)
    );
  };

  const columns = [
    {
      title: "S.No",
      dataIndex: "id",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Document Type",
      dataIndex: "documentType",
      key: "documentType",
    },
    {
      title: "Document Number",
      dataIndex: "documentNumber",
      key: "docnumber",
    },
    {
      title: "Certificate Preview",
      dataIndex: "certificateBase64",
      key: "certificateBase64",
      render: (text) => (
        <img
          src={text}
          alt="Uploaded"
          style={{ width: "100px", height: "auto", objectFit: "cover", borderRadius: 4 }}
        />
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (_, record) => (
        <Popconfirm
          title="Delete the course"
          description="Are you sure to delete this record?"
          onConfirm={() => handleDeleteWaveDocuments(record.id, record.source)}
          okText="Yes"
          cancelText="No"
        >
          <DeleteOutlined />
        </Popconfirm>
      ),
    },
  ];

  const columnsOff = [
    {
      title: "S.No",
      dataIndex: "id",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Question",
      dataIndex: "questionId",
      key: "questionId",
    },
    {
      title: "Answer",
      dataIndex: "answerId",
      key: "answerId",
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (_, record) => (
        <Popconfirm
          title="Delete the course"
          description="Are you sure to delete this record?"
          onConfirm={() => handleDeleteWaveDocuments(record.id)}
          okText="Yes"
          cancelText="No"
        >
          <DeleteOutlined />
        </Popconfirm>
      ),
    },
  ];

  const columns2 = [
    {
      title: "S.No",
      dataIndex: "id",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Document Type",
      dataIndex: "documentType",
      key: "documentType",
    },
    {
      title: "Document Number",
      dataIndex: "documentNumber",
      key: "docnumber",
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (_, record) => (
        <Popconfirm
          title="Delete the course"
          description="Are you sure to delete this record?"
          onConfirm={() => handleDeleteDocument(record.id)}
          okText="Yes"
          cancelText="No"
        >
          <DeleteOutlined />
        </Popconfirm>
      ),
    },
  ];

  const rules = {
    firstName: [
      {
        required: true,
        message: "Please enter first name",
        whitespace: true,
      },
    ],
    lastName: [
      {
        required: true,
        message: "Please enter last name",
        whitespace: true,
      },
    ],
    relationship: [
      ({ getFieldValue }) => ({
        validator(_, value) {
          if (value !== "0" && value !== undefined) {
            return Promise.resolve();
          }
          return Promise.reject("Please select relationship");
        },
      }),
    ],
    dob: [
      {
        required: true,
        message: "Please select date of birth",
      },
    ],
    gender: [
      ({ getFieldValue }) => ({
        validator(_, value) {
          if (value !== "0" && value !== undefined) {
            return Promise.resolve();
          }
          return Promise.reject("Please select gender");
        },
      }),
    ],
    mobile: [
      {
        required: false,
        message: "Please enter mobile number",
        whitespace: false,
      },
      {
        validator: (_, value) => {
          if (!value) {
            return Promise.reject("Please enter mobile number");
          }

          // Basic 10-digit check
          if (!/^[0-9]{10}$/.test(value)) {
            return Promise.reject("Please enter a valid 10-digit mobile number");
          }

          // Country-specific check
          const { selectedCountryCode } = form.getFieldValue(); // Adjust as per your form instance
          const regex = getPhoneRegexByCountry(selectedCountryCode);
          if (!regex.test(value || "")) {
            const countryMessage = getCountryErrorMessage(selectedCountryCode);
            return Promise.reject(`Invalid phone number format: ${countryMessage}`);
          }

          return Promise.resolve();
        },
      },
    ],
    email: [
      {
        required: true,
        message: "Please enter email",
      },
      {
        validator: (_, value) => {
          if (
            !value ||
            /^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/.test(value)
          ) {
            return Promise.resolve();
          } else {
            return Promise.reject("Please enter a valid email");
          }
        },
      },
    ],
    percentage: [
      {
        validator: (_, value) => {
          if (!value || /^\d+(\.\d+)?$/.test(value)) {
            return Promise.resolve();
          } else {
            return Promise.reject("Please enter a valid percentage");
          }
        },
      },
    ],
    academic: [
      ({ getFieldValue }) => ({
        validator(_, value) {
          if (value !== 0 && value !== undefined && value !== null) {
            return Promise.resolve();
          }
          return Promise.reject("Please select academic session");
        },
      }),
    ],
    enrollment: [
      {
        required: false,
        message: "Please enter enrollment",
        whitespace: true,
      },
    ],
    village: [
      ({ getFieldValue }) => ({
        validator(_, value) {
          if (value !== 0 && value !== undefined && value != null) {
            return Promise.resolve();
          }
          return Promise.reject("Please enter village")
        }
      })
    ],
    parentVillage: [
      {
        required: false,
        message: "Please enter village",
        whitespace: false,
      },
    ],
    parentCountry: [
      {
        required: false,
        message: "Please enter country",
        whitespace: true,
      },
    ], parentState: [
      {
        required: false,
        message: "Please enter state",
        whitespace: true,
      },
    ], parentCity: [
      {
        required: false,
        message: "Please enter city",
        whitespace: true,
      },
    ],
    parentCountry: [
      {
        required: false,
        message: "Please enter country",
        whitespace: true,
      },
    ],
    country: [
      {
        required: false,
        message: "Please enter country",
        whitespace: true,
      },
    ],
    state: [
      {
        required: false,
        message: "Please enter state",
        whitespace: true,
      },
    ],
    city: [
      {
        required: false,
        message: "Please enter last city",
        whitespace: true,
      },
    ],
    pincode: [
      {
        required: true,
        message: "Please enter pin code",
      },
    ],
    parentPinCode: [
      {
        required: false,
        message: "Please enter pin code",
      },
    ],
    currentSchool: waveType ? [
      {
        required: false,
        message: "Please enter current school",
        whitespace: true,
      },
    ] : [], previousSchoolsAttended: waveType ? [
      {
        required: false,
        message: "Please enter previous schools attended",
        whitespace: true,
      },
    ] : [], academicAchievements: waveType ? [
      {
        required: false,
        message: "Please enter academic achievement",
        whitespace: true,
      },
    ] : [],
    familyAnnualIncome: waveType ? [
      {
        required: true,
        message: "Please enter family annual income",
        whitespace: true,
      },
    ] : [],
    numberOfDependents: waveType ? [
      {
        required: false,
        message: "Please enter number Of dependents",
        // whitespace: true,
      },
    ] : [],
    financialNeedStatement: waveType ? [
      {
        required: true,
        message: "Please enter financial need statement",
        whitespace: true,
      },
    ] : [],
    waiveoffType: [
      ({ getFieldValue }) => ({
        validator(_, value) {
          if (value !== 0 && value !== undefined && value != null) {
            return Promise.resolve();
          }
          return Promise.reject("Please Select WaveOff Type ")
        }
      })
    ],
    whyDoYouDeserveThisScholarship: [
      ({ getFieldValue }) => ({
        validator(_, value) {
          if (value !== "0" && value !== undefined && value != null) {
            return Promise.resolve();
          }
          return Promise.reject("Please enter why do you deserve this scholarship")
        }
      })
    ],
    // careerGoals: [
    //   {
    //     required: false,
    //     message: "Please enter career goals",
    //     whitespace: true,
    //   },
    //   {
    //     validator: (_, value) => {
    //       if (value && value.trim() === "") {
    //         return Promise.reject("Career goals cannot be empty spaces");
    //       }
    //       return Promise.resolve();
    //     },
    //   },
    // ], 
    answer: [
      {
        required: true,
        message: "Please give answer ",
        whitespace: true,
      },
    ],
    reference1Name: waveType ? [
      {
        required: false,
        message: "Please enter primary reference name",
        whitespace: true,
      },
    ] : [],
    reference1Relationship: waveType ? [
      {
        required: false,
        message: "Please enter primary reference relationship",
        whitespace: true,
      },

    ] : [],
    reference1Contact: waveType ? [
      {
        required: false,
        message: "Please enter primary reference contact",

      },
      {
        validator: (_, value) => {
          if (!value || /^[0-9]{10}$/.test(value)) {
            return Promise.resolve();
          } else {
            return Promise.reject("Please enter a valid contact number");
          }
        },
      },
    ] : [],
    reference2Name: waveType ? [
      {
        required: false,
        message: "Please enter secondary reference name",
        whitespace: true,
      },
    ] : [],
    reference2Relationship: waveType ? [
      {
        required: false,
        message: "Please enter secondary reference relationship",
        whitespace: false,
      },
    ] : [],
    reference2Contact: waveType ? [
      {
        required: false,
        message: "Please enter secondary reference contact",

      },
      {
        validator: (_, value) => {
          if (!value || /^[0-9]{10}$/.test(value)) {
            return Promise.resolve();
          } else {
            return Promise.reject("Please enter a valid contact number");
          }
        },
      },
    ] : [],
    applicantSignature: waveType ? [
      {
        required: false,
        message: "Please enter applicant signature",
        whitespace: true,
      },
    ] : [],
    isWaivedOff: [
      {
        validator: (_, value) =>
          value === undefined
            ? Promise.reject("Please select Waived Off")
            : Promise.resolve(),
      },
    ],
    applicationType: waveType ? [
      {
        required: false,
        message: "Please enter application type",
        whitespace: true,
      },
    ] : [],
    gradeId: waveType ? [
      ({ getFieldValue }) => ({
        validator(_, value) {
          if (value !== "0" && value !== undefined) {
            return Promise.resolve();
          }
          return Promise.reject("Please enter grade type");
        },
      }),
    ] : [],
    passingYears: waveType ? [
      {
        required: false,
        message: "Please enter passing year",
        whitespace: true,
      },
    ] : [],
    SchoolPercentage: waveType ? [
      {
        required: false,
        message: "Please enter Percentage",
        whitespace: true,
      },
    ] : [],


  };

  const saveInfo = () => {
    form.validateFields().then(async (values) => {
      const gradeId =
        selectedCourseList.length > 0 ? selectedCourseList[0].gradeId : null;
      const grade = {
        id: gradeId,
        course: selectedCourseList?.map((course) => ({
          id: course.id,
        })),
      };
      studentData.grade = grade;
      // setStudentData(studentData);
      window.scrollTo(0, 0);


      const data = {
        id: 0,
        fullName: values?.fullName ?? ((studentData?.firstName ?? '') + ' ' + (studentData?.lastName ?? '')) ?? '',
        dateofBirth: values?.dateOfBirth ?? studentData?.dateofBirth ?? '',
        emailAddress: values?.emailAddress ?? studentData?.emailAddress ?? '',
        phoneNumber: values?.phoneNumber ?? studentData?.mobileNumber ?? '',
        // address: studentData?.address.line1 ?? 'Noida',
        address: {
          userId: StudentDetails?.userId,
          line1: values?.address,
          addressTypeId: 1,
          city: values?.city,
          stateId: values?.stateId,
          countryId: 91,
          pinCode: values?.pinCode,
        },
        currentSchool: values?.currentSchool ?? '',
        previousSchoolsAttended: values?.previousSchoolsAttended ?? '',
        academicAchievements: values?.academicAchievements ?? '',
        familyAnnualIncome: +values?.familyAnnualIncome ?? 0,
        numberOfDependents: +values?.numberOfDependents ?? 0,
        financialNeedStatement: values?.financialNeedStatement ?? '',
        // whyDoYouDeserveThisScholarship: values?.whyDoYouDeserveThisScholarship ?? '',
        whyDoYouDeserveThisScholarship: "help",
        studentAnswer: values?.studentAnswer ?? '',
        reference1Name: values?.reference1Name ?? '',
        reference1Relationship: values?.reference1Relationship ?? '',
        reference1Contact: values?.reference1Contact ?? '',
        reference2Name: values?.reference2Name ?? '',
        reference2Relationship: values?.reference2Relationship ?? '',
        reference2Contact: values?.reference2Contact ?? '',
        applicantSignature: values?.applicantSignature ?? '',
        applicationDate: new Date() ?? '',
        isWaivedOff: values?.isWaivedOff ?? '',
        createddate: new Date() ?? '',
        applicationType: values?.applicationType ?? '',
        studentUniqueId: EntredStudenId,
        relationshipId: values?.relationshipId ?? 1,
        academic: {
          userId: StudentDetails?.userId,
          id: 0,
          studentId: StudentDetails?.userId,
          schoolName: values?.schoolName ?? '',
          gradeId: values?.gradeId,
          passingYear: values?.passingYear,
          cgpa: ''
        },
        documents: [
          {
            userId: StudentDetails?.userId,
            id: 0,
            studentId: StudentDetails?.userId,
            typeId: 0,
            name: '',
            documentUrl: ''
          }
        ],
        roleId: 3
      };
      setStudentData((prev) => ({
        ...prev,
        // ...data
      }))
      const waveOffPayload = {
        ...data,
        address: studentData?.address.line1 ?? 'Noida',
      }

      if (waveType && docList.length === 0) {
        message.error("Please add altest one Docuement")
      }

      else {
        if (pageStep === 3 && values?.isWaivedOff == true) {
          try {
            const res = await StudentService.postWaiveoffApplication(waveOffPayload);

            if (res.status === STATUS_CODE.SUCCESS) {
              message.success('Student registered successfully');
              window.scrollTo(0, 0);
            } else {
              message.error('Something went wrong. Please try again.');
            }


          } catch (error) {
            console.error('Error while submitting waiver application:', error);
            message.error('An error occurred. Please check your network or try again later.');
          }
          // }
          // if () {

        }
        if (waiveoffType == "Waiveoff" && waveType) {
          let params = {
            Email: studentData?.emailAddress,
            Documents: file ?? 'image',
            DocumentNumber: docList[0]?.documentNumber,
          };
          //
          StudentService.postSaveincomeDocuments(params).then((res) => {
            if (res.data.statusCode === STATUS_CODE.SUCCESS) {
              message.success(`Student registered successfully`);
              setStep(step + 1);
            } else if (res.data.statusCode === STATUS_CODE.CONFLICT) {
              message.warning(`Email already exists`);
            } else {
              // message.error(`Error in adding`);
            }
          });
          message.success(`Document added successfully`);
          form.resetFields(["waiveoffType", "docnumber", "certificate"]);
        }

        if ((waiveoffType == "Stipend" || waiveoffType == "Scholarship") && waveType) {
          const body = docList
            .filter((val) => val.typeId === 1)
            .map((item) => ({
              studentId: 0,
              question: item.questionId,
              answerText: item.answerId,
            }));

          let param = {
            Email: studentData?.emailAddress,
            Studentname: studentData?.firstName,
            ApplicationId: 124,
            ApplicationType: waiveoffType,
          };
          let finalPayload = {
            Email: param.Email,
            Studentname: param.Studentname,
            ApplicationId: param.ApplicationId,
            ApplicationType: param.ApplicationType,
            answers: body,
          };

          // Update your function like this:
          StudentService.postEvaluateStudentAnswersAsync(finalPayload).then((res) => {
            if (res.data.statusCode === STATUS_CODE.SUCCESS) {
              message.success(`Student registered For Stipend or Scholarship Successfully`);
              setStep(step + 1);
            } else if (res.data.statusCode === STATUS_CODE.CONFLICT) {
              message.warning(`Email already exists`);
            } else {
              // message.error(`Error in adding`);
            }
          });
        }

        if (pageStep === 3 && waiveoffType == 102) {
          const formData = new FormData();

          formData.append("StudentId", studentData?.id ?? studentId ?? '12');
          formData.append(
            "FullName", studentData?.firstName
            // values?.fullName ??
            // ((studentData?.firstName ?? "") + " " + (studentData?.lastName ?? ""))
          );
          formData.append("FathersName", values?.reference1Name ?? "");
          formData.append("Income", values.familyAnnualIncome);
          formData.append("Email", studentData.emailAddress);
          formData.append("ApplicationId", 10); // set as required
          formData.append("Document", file);
          try {
            console.log(formData);
            const waiveOffres = await StudentService.postWaiveoffStudentSubmit(formData);

            if (waiveOffres.status === STATUS_CODE.SUCCESS) {
              message.success('WaiveOff registration successful');
            } else {
              message.error('WaiveOff registration failed.');
            }
            window.scrollTo(0, 0);
          } catch (error) {
            message.error('An error occurred. Please check your network or try again later.');
          }
        }

        if (!studentId) {
          // 
          StudentService.create(studentData).then((res) => {
            if (res.data.statusCode === STATUS_CODE.SUCCESS) {
              setStudentId(res?.data?.id)
              message.success(`Student registered successfully`);
              setStep(step + 1);
            } else if (res.data.statusCode === STATUS_CODE.CONFLICT) {
              setStep(step + 1);
              message.warning(`Email already exists`);
            } else {
              setStep(step + 1);
              message.error(`Error in adding`);
            }
          });
        } else {
          // 
          StudentService.update(studentId, studentData).then((res) => {
            if (res.data.statusCode === STATUS_CODE.SUCCESS) {
              message.success(`Student registered successfully`);
              setStep(step + 1);
              localStorage.clear();
            } else if (res.data.statusCode === STATUS_CODE.CONFLICT) {
              setStep(step + 1);
              message.warning(`Email already exists`);
            } else {
              setStep(step + 1);
              message.error(`Error in updating`);
            }
          });
        }
      }
    }).catch((errorInfo) => {
      console.log("Validation Failed:", errorInfo);
      // errorInfo.errorFields is an array
      errorInfo.errorFields.forEach((err) => {
        console.log("Field:", err.name, "Error:", err.errors);
      })
    });
  };

  const handleNext = (pageStep) => {
    // 
    form
      .validateFields()
      .then((values) => {
        // 
        //Set Student Info
        if (pageStep === 1) {
          const data = {
            userId: StudentDetails?.userId,
            username: values?.emailAddress.toLowerCase(),
            firstName: values?.firstName,
            middleName: values?.middleName,
            lastName: values?.lastName,
            mobileNumber: values?.mobileNumber,
            emailAddress: values?.emailAddress,
            genderId: values?.genderId,
            statusId: 2,
            dateofBirth: values?.dateofBirth,
            nationalityId: 0,
            ethnicityId: values?.ethnicityId ?? 1,
            admissionDate: moment().format("YYYY-MM-DDTHH:mm:ss"),
            password: values?.password,
            enrollmentNumber: values?.enrollmentNumber,
            academicSessionId: values?.academicSessionId,
            studentid: EntredStudenId,
            countryId: values?.countryId,
            pincode: values?.pincode,
            address: {
              userId: StudentDetails?.userId,
              line1: values?.address,
              addressTypeId: 1,
              city: values?.city,
              stateId: values?.stateId,
              countryId: 91,
              pinCode: values?.pinCode,
            },
            academic: {
              userId: StudentDetails?.userId,
              id: 0,
              studentId: StudentDetails?.userId,
              schoolName: studentData?.currentSchool ?? "String",
              gradeId: values?.gradeId,
              passingYear: values?.passingYear,
              cgpa: ''
            },
            documents: [
              {
                userId: StudentDetails?.userId,
                id: 0,
                studentId: StudentDetails?.userId,
                typeId: 0,
                name: '',
                documentUrl: ''
              }
            ],
            roleId: 3
          };
          setStudentData((prev) => ({
            ...prev,
            ...data
          }))
          // setStudentData(data);
          window.scrollTo(0, 0);
        }

        //Set Parent Info
        if (pageStep === 2) {
          // 
          const parentInfo = {
            firstName: values.parentFirstName,
            middleName: values.parentMiddleName,
            lastName: values.parentLastName,
            mobileNumber: values.parentMobileNumber,
            emailAddress: values.parentEmailAddress,
            // relationshipId: values.relationshipId ?? 2,
            relationshipId: 2,
            password: values.parentPassword,
            parentCountryId: values.parentCountryId,
            address: {
              line1: values.parentAddress,
              stateId: values.parentStateId,
              city: values.parentCity,
              pinCode: values.parentPinCode,
            },
          };

          setStudentData((prev) => ({
            ...prev,
            parent: parentInfo
          }));
          window.scrollTo(0, 0);
        }

        if (pageStep === 1) {
          const hasWaiverCourse = selectedCourseList.some(
            (course) => course.isWaiver === true
          );
          if (hasWaiverCourse) {
            form.validateFields().then((values) => {
              if (pageStep === 1) {
                const email = values.emailAddress;
                if (email) {
                  WaiverService.getByEmail(email)
                    .then((res) => {
                      if (res && res.data && res.data.statusCode === 404) {
                        message.warning(
                          `Student is not eligible for waiver / stipend`
                        );
                      } else if (res && res.data && res.status === 200) {
                        setPageStep(pageStep + 1);
                      } else {
                        message.error("Unexpected response from the server.");
                      }
                    })
                    .catch((error) => {
                      console.error("Error:", error);
                      if (error.response && error.response.status === 404) {
                        message.warning(
                          `Student is not eligible for waiver / stipend`
                        );
                      } else {
                        message.error(
                          "An error occurred while fetching student information."
                        );
                      }
                    });
                }
              }
            });
          } else {
            setPageStep(pageStep + 1);
          }
        }
        else {
          setPageStep(pageStep + 1);
        }
      })
      .catch((info) => {
        message.error("Please enter all required field ");
      });
  };

  const arr = [
    { id: 101, name: 'Stipend' },
    { id: 102, name: 'Waiveoff' },
    { id: 103, name: 'Scholarship' }
  ];


  const onFinish = async (values) => {
    // Get the actual file object
    const files = values.certificate?.[0]?.originFileObj;
    if (!files) {
      console.error("No file selected");
      return;
    }

  }


  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    console.log(e.fileList)
    return e?.fileList || [];
  };

  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };


  const handleWaveType = (value) => {
    setWaveType(value);
    if (!value) {
      form.resetFields(["waiveoffType", "docnumber", "certificate", "answer"]);
    }
  }

  const handleWaiveOffTypeChange = (value) => {
    setWaiveoffType(value);
    if (docList.length > 0) {
      if (value === "Stipend" || value === "Scholarship") {
        setDocList((prev) => prev.filter((val) => val.typeId === 1))
      }
      else {
        setDocList((prev) => prev.filter((val) => val.typeId === 2))
      }
    }
  }

  const [file, setFile] = useState(null);

  const customUpload = async (options) => {
    const { file, onSuccess, onError } = options;

    const formData = new FormData();
    formData.append("folderName", "uploads");   // extra data
    formData.append("Image", file);             // the actual file

    try {
      const response = await axios.post(
        "https://stusphere-stg-api.azurewebsites.net/api/UploadImage?folderName=uploads",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setFile(response?.data)
      setFileList([
        {
          uid: file.uid,
          name: file.name,
          status: "done",
          url: response.data,
        },
      ]);
      message.success(`uploaded successfully.`);
      onSuccess(response.data); // call Antd success callback
    } catch (err) {
      console.error(err);
      // message.error(`${file.name} upload failed.`);
      onError(err); // call Antd error callback
    }
  }

  const getCountryErrorMessage = (code) => {
    switch (code) {
      case "+91": return "Indian numbers must start with 6-9 and have 10 digits";
      case "+1": return "US numbers must start with 2-9 and have 10 digits";
      case "+44": return "UK numbers must start with 7 and have 10 digits";
      case "+61": return "Australian numbers must start with 4 and have 9 digits";
      case "+27": return "South African numbers must start with 6-8 and have 9 digits";
      default: return "Number must be between 6 to 15 digits";
    }
  };


  const getPhoneRegexByCountry = (code) => {
    switch (code) {
      case "+91": return /^[6-9]\d{9}$/;
      case "+1": return /^[2-9]\d{9}$/;
      case "+44": return /^7\d{9}$/;
      case "+61": return /^4\d{8}$/;
      case "+27": return /^[6-8]\d{8}$/;
      default: return /^\d{6,15}$/;
    }
  };



  useEffect(() => {
    setLoading(true);
    fetch("https://restcountries.com/v3.1/all?fields=name,cca2,idd,flags")
      .then((res) => res.json())
      .then((data) => {
        const formatted = data
          .map((c) => {
            const root = c?.idd?.root || "";
            const suf = c?.idd?.suffixes?.[0] || "";
            const dial = (root + suf).replace(/\s/g, "");
            return dial
              ? {
                code: c.cca2,
                name: c.name.common,
                dialCode: dial,
                flag: c.flags.svg,
              }
              : null;
          })
          .filter(Boolean)
          .sort((a, b) => a.name.localeCompare(b.name));
        setCountryCodeList(formatted);
      })
      .finally(() => setLoading(false));
  }, []);

  const countryTemplate = (country) => (
    <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
      <img
        src={country.flag}
        alt="flag"
        style={{
          width: 20,
          height: 14,
          objectFit: "cover",
          borderRadius: 3,
        }}
      />
      {country.name} ({country.dialCode})
    </span>
  );




  const getPincodeData = async (pin) => {
    setLoading(true);
    try {
      const response = await fetch("https://api.peoplebook.in/api/v1/Master/GetPincodeData", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": "Bearer PB-DEC-RRAP-BIZBR-2021OLLY"
        },
        body: JSON.stringify({ Pincode: pin })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      const uniqueVillages = Object.values(
        data?.Result.reduce((acc, item) => {
          if (!acc[item.VillageName]) {
            acc[item.VillageName] = item;
          }
          return acc;
        }, {})
      );
      setPincodeData(uniqueVillages);
      if (parsedStudentData?.ParentAddress?.City) {
        let vill = data?.Result?.filter((el) => parsedStudentData?.ParentAddress?.City == el?.VillageName)
        getVillageData(vill[0]?.Id, 1);
        getVillageData(vill[0]?.Id, 2);
      }
      setLoading(false);

    } catch (error) {
      setLoading(false);
      console.error("Error fetching pincode data:", error);
    }
  };

  const getVillageData = async (Id, type) => {
    setLoading(true);
    try {
      const response = await fetch("https://api.peoplebook.in/api/v1/Master/GetVillageData", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": "Bearer PB-DEC-RRAP-BIZBR-2021OLLY"
        },
        body: JSON.stringify({ Id: Id })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      setLoading(false);
      if (type == 1) {
        form.setFieldValue('country', data?.Result[0]?.countrynAME || '');
        form.setFieldValue('state', data?.Result[0]?.StateName || '');
        form.setFieldValue('city', data?.Result[0]?.DistrictName || '');
        form.setFieldValue('village', data?.Result[0]?.villageName || '');

      } else {
        form.setFieldValue('parentCountry', data?.Result[0]?.countrynAME || '');
        form.setFieldValue('parentState', data?.Result[0]?.StateName || '');
        form.setFieldValue('parentCity', data?.Result[0]?.DistrictName || '');
        form.setFieldValue('parentVillage', data?.Result[0]?.villageName || '');
      }



    } catch (error) {
      setLoading(false);
      console.error("Error fetching pincode data:", error);
    }
  };


  const handleInputChange = (event) => {
    const value = event;
    if (value.length === 6) {
      debouncedSearch(value);
    }
  };

  const debouncedSearch = useCallback(
    debounce((value) => {
      getPincodeData(value); // ✅ call API directly
    }, 500),
    []
  );

  const GetStudentQuestion = async () => {
    try {
      let res = await StudentService?.getStudentQuestion();
      setQuestionData(res?.data);
    } catch (err) {

    }
  }


  const PersonalInfo = () => {
    return (
      <div>
        <h2 className="widget-title text-left">Personal Information</h2>

        <div className="justified p-2 enrollment-form">
          <Form
            layout="vertical"
            form={form}
            name="advanced_search"
            className="ant-advanced-search-form"
          >
            <Row gutter={24}>
              <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item
                  name="firstName"
                  label="First Name"
                  rules={rules.firstName}
                >
                  <Input placeholder="First Name" maxLength={100} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item name="middleName" label="Middle Name">
                  <Input placeholder="Middle Name" maxLength={100} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item
                  name="lastName"
                  label="Last Name"
                  rules={rules.lastName}
                >
                  <Input placeholder="Last Name" maxLength={100} />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item
                  name="dateofBirth"
                  label="Date of Birth"
                  rules={rules.dob}
                >
                  <DatePicker
                    name="dateofBirth"
                    placeholder="MM/DD/YYYY"
                    format="MM/DD/YYYY"
                    className="w-100"
                    disabledDate={(current) =>
                      current && current > moment().endOf("day")
                    }
                    inputReadOnly
                  />
                </Form.Item>
              </Col>
              <Col xs={12} sm={12} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item
                  name="genderId"
                  label="Gender"
                  rules={rules.gender}
                  required
                >
                  <Select placeholder="Gender" defaultValue="Select Gender">
                    <Option value="0">Select Gender</Option>
                    {genderList?.map((elm) => (
                      <Option key={elm.id} value={elm.id}>
                        {elm.title}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={12} sm={12} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item name="ethnicityId" label="Ethnicity" >
                  <Select placeholder="Ethnicity" defaultValue="Select Ethnicity">
                    <Option value="0">Select Ethnicity</Option>
                    {ethnicityListData?.map((elm) => (
                      <Option key={elm.id} value={elm.id}>
                        {elm.title}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>

              </Col>

              <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item
                  name="emailAddress"
                  label="Email"
                  rules={rules.email}
                >
                  <Input placeholder="Email" maxLength={50} disabled={isActive} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item
                  label="Country Code"
                  name="selectedCountryCode"

                  rules={[{ required: false, message: "Please select code" }]}
                >
                  <Select
                    placeholder="Country Code"
                    showSearch
                    optionFilterProp="label" // 👈 search uses this
                    notFoundContent={loading ? <Spin size="small" /> : null}
                  >
                    {countryCodeList.map((country) => (
                      <Option
                        key={country.dialCode}
                        value={country.dialCode}
                        label={`${country.name} ${country.dialCode}`}
                      >
                        {countryTemplate(country)}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>

              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>

                <Form.Item
                  name="mobileNumber"
                  label="Mobile Number"
                  rules={[
                    { required: false, message: "Please enter mobile number" },
                    { pattern: /^[0-9]{10}$/, message: "Enter valid 10-digit number" },
                  ]}
                >
                  <Input
                    placeholder="Mobile Number"
                    maxLength={10}
                    onKeyDown={(event) => {
                      if (
                        event.key !== "Delete" &&
                        event.key !== "Backspace" &&
                        event.key !== "ArrowLeft" &&
                        event.key !== "ArrowRight" &&
                        !/[0-9]/.test(event.key)
                      ) {
                        event.preventDefault();
                      }
                    }}
                    onPaste={(e) => {
                      e.preventDefault();
                      return false;
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
            </Row>
            <Row gutter={24}>
              <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                <Form.Item name="address" label="Address">
                  <Input.TextArea
                    placeholder="Address"
                    rows={4}
                    maxLength={200}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>

              <Col xs={12} sm={12} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item
                  name="pincode"
                  label="PIN Code"
                  rules={rules.pincode}
                  required
                >
                  <Input
                    type="number"
                    placeholder="PIN Code"
                    style={{ color: "#000", background: "#fff" }}
                    suffix={loading ? <Spin size="small" /> : null}
                    onInput={(e) => {
                      let val = e.target.value;

                      // restrict to 6 digits max
                      if (val.length > 6) {
                        val = val.slice(0, 6);
                        e.target.value = val;
                      }

                      // call function when 6 digits entered
                      if (val.length === 6) {
                        handleInputChange(val);
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={12} sm={12} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item name="village" label="Village"
                  rules={rules.village}
                  required
                >
                  <Select
                    placeholder="Select Village"
                    defaultValue="Select Village"
                    onChange={(value) => getVillageData(value, 1)}
                  >
                    <Option value="0">Select Village</Option>
                    {pincodeData?.map((elm) => (
                      <Option key={elm.VillageName} value={elm.Id}>
                        {elm.VillageName}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item name="city" label="City" rules={rules.city}>
                  <Input placeholder="City" maxLength={100} disabled={true} />
                </Form.Item>
              </Col>
              <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6}>
                <Form.Item name="state" label="State" rules={rules.state} >
                  <Input placeholder="State" maxLength={100} disabled={true} />
                </Form.Item>
              </Col>
              <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6}>
                <Form.Item name="country" label="Country"
                  rules={rules.country}
                  required
                >
                  <Input placeholder="Country" maxLength={100} disabled={true} />
                </Form.Item>
              </Col>
              <Col xs={8} sm={8} md={6} lg={6} xl={6} xxl={6}>
                <Form.Item
                  name="academicSessionId"
                  label="Academic Year"
                  rules={rules.academic}
                  required
                >
                  <Select
                    placeholder="Academic Year"
                    defaultValue="Select Session"
                  >
                    <Option value={0}>Select Academic</Option>
                    {academicSession?.data?.map((elm) => (
                      <Option key={elm.id} value={elm.id}>
                        {elm.title}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={8} md={6} lg={6} xl={6} xxl={6}>
                <Form.Item
                  name="enrollmentNumber"
                  label="Enrollment"
                  rules={rules.enrollment}
                >
                  <Input placeholder="Enrollment" maxLength={10} />
                </Form.Item>
              </Col>
            </Row>

          </Form>
        </div>
      </div>
    );
  };

  const ParentInfo = () => {
    return (
      <div>
        <h2 className="widget-title text-left">Parent Information</h2>

        <div className="justified p-2">
          <Form
            layout="vertical"
            form={form}
            name="advanced_search"
            className="ant-advanced-search-form"
          >
            <Row gutter={24}>
              <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item
                  name="parentFirstName"
                  label="First Name"
                  rules={rules.firstName}
                >
                  <Input placeholder="First Name" maxLength={100} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item name="parentMiddleName" label="Middle Name">
                  <Input placeholder="Middle Name" maxLength={100} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item
                  name="parentLastName"
                  label="Last Name"
                  rules={rules.lastName}
                >
                  <Input placeholder="Last Name" maxLength={100} />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item
                  name="relationshipId"
                  label="Relationship"
                  rules={rules.relationship}
                  required
                >
                  <Select
                    placeholder="Relationship"
                    defaultValue="Select Relationship"
                  >
                    <Option value="0">Select Relationship</Option>
                    {relationshipListData?.map((elm) => (
                      <Option key={elm.id} value={elm.id}>
                        {elm.title}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item
                  label="Country Code"
                  name="countryCode"
                  rules={[{ required: false, message: "Please select code" }]}
                >
                  <Select
                    placeholder="Country Code"
                    showSearch
                    optionFilterProp="label" // 👈 search uses this
                    notFoundContent={loading ? <Spin size="small" /> : null}
                  >
                    {countryCodeList.map((country) => (
                      <Option
                        key={country.code}
                        value={country.dialCode}
                        label={`${country.name} ${country.dialCode}`} // 👈 searchable text
                      >
                        {countryTemplate(country)}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item
                  name="parentMobileNumber"
                  label="Mobile Number"
                  // rules={rules.mobile}
                  rules={[
                    { required: false, message: "Please enter mobile number" },
                    { pattern: /^[0-9]{10}$/, message: "Enter valid 10-digit number" },
                  ]}
                >
                  <Input
                    placeholder="Mobile Number"
                    maxLength={10}
                    onKeyDown={(event) => {
                      if (
                        event.key !== "Delete" &&
                        event.key !== "Backspace" &&
                        event.key !== "ArrowLeft" &&
                        event.key !== "ArrowRight" &&
                        !/[0-9]/.test(event.key)
                      ) {
                        event.preventDefault();
                      }
                    }}
                    onPaste={(e) => {
                      e.preventDefault();
                      return false;
                    }}
                  />
                </Form.Item>
              </Col>

            </Row>
            <Row gutter={24}>
              <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item
                  name="parentEmailAddress"
                  label="Email"
                  rules={rules.email}
                >
                  <Input placeholder="Email" maxLength={50} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item name="parentPassword" label="New Password">
                  <Input.Password
                    placeholder="********"
                    maxLength={50}
                    visibilityToggle={{
                      visible: false,
                      onVisibleChange: (visible) => {
                        console.log("Password visible:", visible);
                      },
                    }}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item name="confirmPassword" label="Confirm Password">
                  <Input.Password
                    placeholder="********"
                    maxLength={50}
                    visibilityToggle={true}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item name="parentAddress" label="Address">
                  <Input.TextArea
                    placeholder="Address"
                    rows={4}
                    maxLength={200}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item
                  name="parentPinCode"
                  label="PIN Code"
                  rules={rules.parentPinCode}
                // required
                >
                  <Input
                    type="number"
                    placeholder="PIN Code"
                    style={{ color: "#000", background: "#fff" }}
                    suffix={loading ? <Spin size="small" /> : null}
                    onInput={(e) => {
                      let val = e.target.value;

                      // restrict to 6 digits max
                      if (val.length > 6) {
                        val = val.slice(0, 6);
                        e.target.value = val;
                      }

                      // call function when 6 digits entered
                      if (val.length === 6) {
                        handleInputChange(val);
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={12} sm={12} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item name="parentVillage" label="Village" rules={rules.parentVillage}>
                  <Select
                    placeholder="Select Village"
                    defaultValue="Select Village"
                    onChange={(value) => getVillageData(value, 2)}
                  >
                    <Option value="0">Select Village</Option>
                    {pincodeData?.map((elm) => (
                      <Option key={elm.VillageName} value={elm.Id}>
                        {elm.VillageName}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item name="parentCity" label="City" rules={rules.parentCity}>
                  <Input placeholder="City" maxLength={100} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item name="parentState" label="State"
                  rules={rules.parentState}>
                  <Input placeholder="State" maxLength={100} disabled={true} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item name="parentCountry" label="Country"
                  rules={rules.parentCountry} >
                  <Input placeholder="Country" maxLength={100} disabled={true} />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    );
  };

  const AcademicInfo = () => {
    return (
      <div>
        <h2 className="widget-title text-left">Academic Information</h2>
        <div className="justified p-2">
          <Form
            layout="vertical"
            form={form}
            onFinish={onFinish}
            name="advanced_search"
            className="ant-advanced-search-form"
          >
            <Row gutter={24}>
              <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item
                  name="isWaivedOff"
                  initialValue={false}
                  label="Select Waived Off"
                  rules={rules.isWaivedOff}
                >
                  <Select
                    placeholder="Select Option"
                    onChange={(value) => handleWaveType(value)}
                  >
                    <Option value={true}>Yes</Option>
                    <Option value={false}>No</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item
                  name="gradeId"
                  label="Grade"
                  rules={rules?.gradeId}
                  initialValue="0"
                >
                  <Select
                    disabled={!waveType}
                    placeholder="Select Grade"
                    defaultValue="Select Grade"
                  >
                    <Option value="0">Select Grade</Option>
                    {props.courseList?.map((elm) => (
                      <Option key={elm.id} value={elm.id}>
                        {elm.title}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item
                  name="passingYear"
                  label="Passing Year"
                  rules={
                    waveType
                      ? [
                        {
                          required: false,
                          message: "Please select passing year",
                        },
                        // {
                        //   validator: (_, value) =>
                        //     value === "0" ? Promise.reject("Please select passing year") : Promise.resolve(),
                        // },
                      ]
                      : []
                  }
                  initialValue="0"
                >
                  <Select
                    placeholder="Select Year"
                    defaultValue="Select Year"
                    disabled={!waveType}
                  >
                    <Option value="0">Select Year</Option>
                    {passingYear?.map((elm) => (
                      <Option key={elm} value={elm}>
                        {elm}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item
                  name="currentSchool"
                  label="Current School"
                  rules={rules?.currentSchool}
                >
                  <Input
                    placeholder="Current School"
                    maxLength={30}
                    disabled={!waveType}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item
                  name="cgpa"
                  label="Percentage/Grade"
                  rules={rules?.SchoolPercentage}
                >
                  <Input
                    placeholder="Percentage"
                    maxLength={30}
                    disabled={!waveType}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item
                  name="previousSchoolsAttended"
                  label="Previous Schools Attended"
                  rules={rules?.previousSchoolsAttended}
                >
                  <Input
                    placeholder="Previous Schools Attended"
                    maxLength={30}
                    disabled={!waveType}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item
                  name="academicAchievements"
                  label="Ademic Achievements"
                  rules={rules?.academicAchievements}
                >
                  <Input
                    placeholder="Academic Achievements"
                    maxLength={30}
                    disabled={!waveType}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item
                  name="familyAnnualIncome"
                  label="Family Annual Income"
                  rules={rules.familyAnnualIncome}
                >
                  <Input
                    disabled={!waveType}
                    placeholder="Family Annual Income"
                    maxLength={10}
                    onKeyDown={(event) => {
                      if (
                        event.key !== "Delete" &&
                        event.key !== "Backspace" &&
                        event.key !== "ArrowLeft" &&
                        event.key !== "ArrowRight" &&
                        !/[0-9]/.test(event.key)
                      ) {
                        event.preventDefault();
                      }
                    }}
                    onPaste={(e) => {
                      e.preventDefault();
                      return false;
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item
                  name="numberOfDependents"
                  label="Number Of Dependents"
                  rules={rules.numberOfDependents}
                >
                  <Input
                    disabled={!waveType}
                    placeholder="Number Of Dependents"
                    maxLength={1}
                    onKeyDown={(event) => {
                      if (
                        event.key !== "Delete" &&
                        event.key !== "Backspace" &&
                        event.key !== "ArrowLeft" &&
                        event.key !== "ArrowRight" &&
                        !/[0-9]/.test(event.key)
                      ) {
                        event.preventDefault();
                      }
                    }}
                    onPaste={(e) => {
                      e.preventDefault();
                      return false;
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item
                  name="financialNeedStatement"
                  label="Financial Need Statement"
                  rules={rules.financialNeedStatement}
                >
                  <Input
                    placeholder="Financial Need Statement"
                    maxLength={30}
                    disabled={!waveType}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item
                  name="reference1Name"
                  label="Primary Reference Name"
                  rules={rules.reference1Name}
                >
                  <Input
                    placeholder="Primary Reference Name:"
                    maxLength={30}
                    disabled={!waveType}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item
                  name="reference1Relationship"
                  label="Primary Relationship"
                  rules={rules.reference1Relationship}
                >
                  <Input
                    placeholder="Primary Relationship"
                    maxLength={30}
                    disabled={!waveType}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item
                  name="reference1Contact"
                  label="Primary Reference Contact"
                  rules={rules.reference1Contact}
                >
                  <Input
                    maxLength={10}
                    style={{ color: "#000", background: "#fff" }}
                    onKeyDown={(event) => {
                      if (
                        event.key !== "Delete" &&
                        event.key !== "Backspace" &&
                        event.key !== "ArrowLeft" &&
                        event.key !== "ArrowRight" &&
                        !/[0-9]/.test(event.key)
                      ) {
                        event.preventDefault();
                      }
                    }}
                    onPaste={(e) => {
                      e.preventDefault();
                      return false;
                    }}
                    placeholder="Primary Reference Contact"
                    disabled={!waveType}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item
                  name="reference2Name"
                  label="Secondary Reference Name"
                  rules={rules.reference2Name}
                >
                  <Input
                    placeholder="Secondary Reference Name"
                    maxLength={30}
                    disabled={!waveType}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item
                  name="reference2Relationship"
                  label="Secondary Relationship"
                  rules={rules.reference2Relationship}
                >
                  <Input
                    placeholder="Secondary Relationship"
                    maxLength={30}
                    disabled={!waveType}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item
                  name="reference2Contact"
                  label="Secondary Reference Contact"
                  rules={rules?.reference2Contact}
                >
                  <Input
                    style={{ color: "#000", background: "#fff" }}
                    onKeyDown={(event) => {
                      if (
                        event.key !== "Delete" &&
                        event.key !== "Backspace" &&
                        event.key !== "ArrowLeft" &&
                        event.key !== "ArrowRight" &&
                        !/[0-9]/.test(event.key)
                      ) {
                        event.preventDefault();
                      }
                    }}
                    onPaste={(e) => {
                      e.preventDefault();
                      return false;
                    }}
                    placeholder="Secondary Reference Contact"
                    maxLength={10}
                    disabled={!waveType}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
                <Form.Item
                  name="applicantSignature"
                  label="Applicant Signature"
                  rules={rules.applicantSignature}
                >
                  <Input
                    placeholder="Applicant Signature"
                    maxLength={30}
                    disabled={!waveType}
                  />
                </Form.Item>
              </Col>
              <Form.Item
                name="Incomecertificate"
                label="Upload Certificate"
              >
                <Upload
                  customRequest={customUpload}
                  showUploadList={true}
                  fileList={certificateFile}
                  onChange={({ info }) => setFileList(info?.certificateFile)}
                  accept="image/*"
                  maxCount={1}
                  disabled={!waveType}
                >
                  <Button icon={<UploadOutlined />}>Click to Upload</Button>
                </Upload>
                {file && (
                  <img src={file} />
                )}

              </Form.Item>

            </Row>
            <Card>
              <div className="pt-4">
                <h5 className="mb-4">Schoolership Detail</h5>
              </div>
              <Row gutter={24}>
                <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
                  <Form.Item
                    name="waiveoffType"
                    label="Choose Admission Type"
                    rules={waveType && docList.length == 0 ? rules.waiveoffType : []}
                  >
                    <Select
                      placeholder="Choose Admission Type"
                      disabled={!waveType}
                      onChange={(value) => {
                        handleWaiveOffTypeChange(value)
                      }}
                    >
                      <Option value="0">Select Type</Option>
                      {arr?.map((elm) => (
                        <Option key={elm.id} value={elm.name}>
                          {elm.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                {waiveoffType === "Waiveoff" ? (
                  <>
                    <Col xs={8} sm={8} md={4} lg={4} xl={4} xxl={4}>
                      <Form.Item name="docnumber" label="Certificate Number">
                        <Input
                          placeholder="Document Number"
                          maxLength={50}
                          disabled={!waveType}
                        />
                      </Form.Item>
                    </Col>

                    <Col
                      xs={8}
                      sm={8}
                      md={4}
                      lg={4}
                      xl={4}
                      xxl={2}
                      style={{ maxWidth: "none" }}
                    >
                      <Form.Item
                        name="certificate"
                        label="Upload Certificate"
                        valuePropName="fileList"
                        getValueFromEvent={normFile}
                      >
                        <Upload
                          name="file"
                          beforeUpload={() => false}
                          maxCount={1}
                          disabled={!waveType}
                        >
                          <Button
                            icon={<UploadOutlined />}
                            disabled={!waveType}
                          >
                            Click to Upload
                          </Button>
                        </Upload>
                      </Form.Item>
                    </Col>
                  </>
                ) : (
                  <>
                    <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
                      <Form.Item
                        name="whyDoYouDeserveThisScholarship"
                        label="Why Do You Deserve This Scholarship"
                        rules={(waveType && (waiveoffType == "Scholarship" || waiveoffType == "Stipend")) ? rules.whyDoYouDeserveThisScholarship : []}
                      >
                        <Select
                          placeholder="Why Do You Deserve This Scholarship"
                          disabled={!waveType}
                          onChange={(value) => setQuestion(value)}
                        >
                          <Option value="0">Select Type</Option>
                          {questionData?.map((elm) => (
                            <Option key={elm.id} value={elm.id}>
                              {elm.question}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={8} sm={8} md={8} lg={4} xl={4} xxl={4}>
                      <Form.Item
                        name="answer"
                        label="Answer"
                        rules={(waveType && (waiveoffType == "Scholarship" || waiveoffType == "Stipend")) && docList.length == 0 ? rules.answer : []}
                      >
                        <Input
                          placeholder="Your Answer"
                          maxLength={30}
                          disabled={!waveType}
                        />
                      </Form.Item>
                    </Col>

                    {/* <Col xs={8} sm={8} md={8} lg={4} xl={4} xxl={4}>
                      <Form.Item
                        name="careerGoals"
                        label="Career Goals"
                        rules={rules.careerGoals}
                      >
                        <Input
                          placeholder="Enter Career Goals"
                          maxLength={30}
                          disabled={!waveType}
                        />
                      </Form.Item>
                    </Col> */}
                  </>
                )}

                <Col
                  xs={6}
                  sm={8}
                  md={2}
                  lg={2}
                  xl={2}
                  xxl={2}
                  style={{ marginTop: "27px" }}
                >
                  <Button
                    type="primary"
                    className="mehroon-btn"
                    danger
                    style={{
                      backgroundColor: "#e20707",
                      borderColor: "#e20707",
                    }}
                    onClick={handleAddAdmitDocument}
                    disabled={!waveType}
                  >
                    + Add
                  </Button>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                  <h6>Document List</h6>
                  <div className="table-responsive pt-5">
                    <Table
                      dataSource={(waiveoffType === "Stipend" || waiveoffType === "Scholarship") ? docList.filter((val) => val.typeId === 1) : docList.filter((val) => val.typeId === 2)}
                      columns={waiveoffType === "Waiveoff" ? columns : columnsOff}
                      pagination={false}
                      rowKey={(record) => record.id}
                    />
                  </div>
                </Col>
              </Row>
              {/* } */}
            </Card>

            <Card>
              <div className="pt-4">
                <h5 className="mb-4">Document Detail</h5>
              </div>
              <Row gutter={24}>
                <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
                  <Form.Item name="documentId" label="Document Type">
                    <Select
                      placeholder="Select Document Type"
                      defaultValue="Select Document Type"
                    >
                      <Option value="0">Select Document Type</Option>
                      {documentListData?.map((elm) => (
                        <Option key={elm.id} value={elm.id}>
                          {elm.title}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
                  <Form.Item name="documentnumber" label="Document Number">
                    <Input placeholder="Document Number" maxLength={50} />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
                  <div className="row text-center">
                    <div className="col-lg-12 col-md-12">
                      <button
                        type="button"
                        className="btn clearfix login-btn width-15 mt-5"
                        data-bs-dismiss="modal"
                        onClick={handleAddDocument}
                      >
                        <span className="btn-wrap">
                          <span className="text-one">+ Add</span>
                          <span className="text-two">+ Add</span>
                        </span>
                      </button>
                    </div>
                  </div>
                </Col>
              </Row>

              <Row gutter={24}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                  <h6>Uploaded Document List</h6>
                  <div className="table-responsive pt-5">
                    <Table
                      dataSource={documentList}
                      columns={columns2}
                      pagination={false}
                      rowKey={(record) => record.id}
                    />
                  </div>
                </Col>
              </Row>
            </Card>
          </Form>
        </div>
      </div>
    );
  };

  return (
    <div className="default-form">
      <div className="title-box">
        <div className="title p-3">
          <h5>Admission</h5>
        </div>

        {pageStep === 1 ? <PersonalInfo /> : null}

        {pageStep === 2 ? <ParentInfo /> : null}

        {pageStep === 3 ? <AcademicInfo /> : null}

        <div className="row">
          <div className="col-lg-6 col-md-6"></div>
          <div className="col-lg-6 col-md-6 text-align-right">

            <Button
              type="primary"
              htmlType="submit"
              className="btn clearfix login-btn width-15"
              onClick={() => setStep(step - 1)}
            >
              <span className="btn-wrap">
                <span className="text-one p-1">Back</span>
                <span className="text-two p-1">Back</span>
              </span>
            </Button>


            {pageStep > 1 ? (
              <Button
                type="primary"
                htmlType="submit"
                className="btn clearfix login-btn width-15"
                onClick={() => {
                  setPageStep(pageStep - 1);
                  window.scrollTo(0, 0);
                }}
              >
                <span className="btn-wrap">
                  <span className="text-one p-1">Prev</span>
                  <span className="text-two p-1">Prev</span>
                </span>
              </Button>
            ) : null}
            {pageStep < 3 ? (
              <Button
                type="primary"
                htmlType="submit"
                className="btn clearfix login-btn width-15 "
                onClick={() => handleNext(pageStep)}
              >
                <span className="btn-wrap">
                  <span className="text-one p-1">Next</span>
                  <span className="text-two p-1">Next</span>
                </span>
              </Button>
            ) : null}

            {pageStep === 3 ? (
              <Button
                type="primary"
                htmlType="submit"
                className="btn clearfix login-btn width-15 "
                onClick={() => saveInfo()}
              >
                <span className="btn-wrap">
                  <span className="text-one p-1">Save</span>
                  <span className="text-two p-1">Save</span>
                </span>
              </Button>
            ) : null}
          </div>
        </div>

        {/* Form Button */}
      </div>
    </div>
  );
};

export default StudentInfo;
